module.exports = require("vue-class-component");